import type { AllRouteEndpoints } from "../routeTypes";
export const generativeAiGptAssistantCacheKeys: AllRouteEndpoints[] = [];
